<template>
    <single-select :config="config" :key="config.storeField"></single-select>
</template>
<script>
    import SingleSelect from '../template/SingleSelect';

    export default {
        components: {SingleSelect},
        data: function () {
            return {
                config: {
                    question: 'What is your ethnicity?',
                    options: [
                        'Hispanic, or Spanish origin',
                        'Not Hispanic, or Spanish origin',
                        'Prefer not to share'
                    ],
                    storeField: 'ethnicity',
                    clickBack: function () {
                        this.$router.go(-1)
                    }.bind(this),
                    clickContinue: async function () {
                        await this.$router.push('/reg/emergency')
                    }.bind(this)
                }
            }
        }
    }
</script>
